import * as React from "react";
import { useEffect } from "react";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import { useIntl } from "react-intl";
import { jsx as _jsx } from "react/jsx-runtime";
const findPeakHour = (chartData, legend) => {
  let maxTotalCount = 0;
  let peakHour = 0;

  // Find maximum count
  for (let index = 0; index < chartData.length; index++) {
    if (maxTotalCount < chartData[index].value) {
      maxTotalCount = chartData[index].value;
    }
  }

  // Set color based on maxTotalCount
  for (let index = 0; index < chartData.length; index++) {
    const dataItem = chartData[index];

    // Check if the dataItem has necessary properties
    if (dataItem && dataItem.value !== undefined && dataItem.x !== undefined) {
      if (dataItem.value === maxTotalCount) {
        dataItem.fillOpacity = 1;
        dataItem.color = legend.maxColor;
        dataItem.stroke = legend.maxColor;
        peakHour = dataItem.x;
      } else {
        dataItem.fillOpacity = 0.7; // Adjusted opacity for non-maximum values
        dataItem.color = legend.nonMaxColor;
        dataItem.stroke = legend.nonMaxColor;
      }
    }
  }
  return peakHour;
};
const XYLineChart = ({
  chartData,
  legend,
  intl
}) => {
  const randomID = (Math.random() + 1).toString(36).substring(8);
  const bodyStyles = window.getComputedStyle(document.body);
  const defaultBgColor = bodyStyles.getPropertyValue("--kc-white-color");
  const defaultLabelColor = bodyStyles.getPropertyValue("--kc-border-color");
  useEffect(() => {
    const chart = am4core.create(randomID, am4charts.XYChart);
    chart.data = chartData;
    chart.zoomOutButton.disabled = true;
    if (chart.logo) {
      chart.logo.disabled = true;
    }

    // Create axes
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "x"; //"hours"x
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 0;
    categoryAxis.renderer.labels.template.disabled = true;
    categoryAxis.renderer.grid.template.disabled = true;
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.min = 0;

    // Configure Ticks
    if (chart.data.length > 0) {
      categoryAxis.renderer.ticks.template.disabled = false;
      categoryAxis.renderer.ticks.template.length = 5;
      categoryAxis.renderer.ticks.template.strokeOpacity = 1;
      categoryAxis.renderer.ticks.template.stroke = am4core.color(legend.strokeColor);
      categoryAxis.renderer.ticks.template.strokeWidth = 1;
    }
    let series = {};
    series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "value"; //"totalcount"
    series.dataFields.categoryX = "x"; // "hours";
    series.dataFields.tootltipY = "tooltipNum";
    series.name = intl.formatMessage({
      id: legend.text
    });
    series.columns.template.width = am4core.percent(93);
    series.columns.template.tooltipText = `${intl.formatMessage({
      id: legend.text
    })}: [bold]{tooltipY}[/]`;
    series.tooltip.label.adapter.add("textOutput", (_, target) => {
      if (target.dataItem.dataContext && target.dataItem.dataContext.value) {
        return ` ${legend.text}: [bold]${target.dataItem.dataContext.value}[/]`;
      } else {
        return `${intl.formatMessage({
          id: legend.text
        })} : `;
      }
    });

    // Set color properties based on findPeakHour
    findPeakHour(chartData, legend);
    series.columns.template.propertyFields.fillOpacity = 'fillOpacity';
    series.columns.template.propertyFields.fill = 'color';
    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color(defaultBgColor);
    series.tooltip.label.fill = am4core.color(defaultLabelColor);
    const columnTemplate = series.columns.template;
    columnTemplate.strokeWidth = 0;
    columnTemplate.strokeOpacity = 0;

    // Cleanup function when component unmounts
    return () => {
      chart.dispose();
    };
  }, [chartData, legend]);
  return /*#__PURE__*/_jsx("div", {
    className: "kc-ui-xy-line-chart",
    id: randomID
  });
};
const _XYLineChartWidget = props => {
  const {
    chartData,
    legend
  } = props;
  const [chartValue, setChartValue] = React.useState(chartData);
  const intl = useIntl();
  React.useEffect(() => {
    setChartValue(chartData);
  }, [chartData]);
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "kc-ui-trend-wrapper",
      children: chartData.length ? /*#__PURE__*/_jsx(XYLineChart, {
        chartData: chartValue,
        legend: legend,
        intl: intl
      }) : null
    })
  });
};
// Default props
_XYLineChartWidget.defaultProps = {
  chartData: [],
  legend: {}
};
export const XYLineChartWidget = /*#__PURE__*/React.memo(_XYLineChartWidget);